import { render } from "./LatestNews.vue?vue&type=template&id=dec70342&scoped=true"
import script from "./LatestNews.vue?vue&type=script&lang=js"
export * from "./LatestNews.vue?vue&type=script&lang=js"

import "./LatestNews.vue?vue&type=style&index=0&id=dec70342&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dec70342"]])

export default __exports__